module.exports = __webpack_public_path__ + "static/media/wellnite-auth-hero_787.f927f1ea.png";